import { useTranslation } from 'react-i18next'

import { Body1, Body2 } from '@ui/Typography'
import { RichIcon } from '@ui/components/RichIcon'
import { TradingViewIcon } from '@ui/icons/platforms/TradingView.icon'
import { TableNoResults } from '@ui/v2/Table/Table'

import { formatDate } from '@utils/date.utils'
import { useWindowResize } from '@utils/domUtils'

import { Box, type BoxProps } from '@shared/components/Box'
import { Loading } from '@shared/components/Loading/Loading'

import { useRewardsHistory } from './hooks/useRewardsHistory'

export const RewardsHistoryTab = () => {
  const { rewardsHistory, isLoading } = useRewardsHistory()
  const { t } = useTranslation()
  const isMobile = useWindowResize()

  const styleProps: BoxProps = isMobile
    ? { direction: 'column', gap: 'x8' }
    : { align: 'center', justify: 'space-between', gap: 'x16' }

  return (
    <Loading isLoading={isLoading}>
      <Box flex direction='column' gap='x16'>
        {!rewardsHistory.length ? (
          <TableNoResults
            renderTitle={() => (
              <Body1 semibold color='text-med-em'>
                {t('RewardsHub.Your history will appear here')}
              </Body1>
            )}
          />
        ) : (
          rewardsHistory.map((reward) => (
            <Box
              flex
              key={`${reward.tradingAccount.id}-${reward.tradingViewPlan.id}-${reward.assignmentDate}`}
              fullWidth
              {...styleProps}
            >
              <Box flex gap='x8'>
                <RichIcon icon={TradingViewIcon} size='x24' />
                <Body2 semibold>{t('RewardsHub.TradingViewPlan')}</Body2>
              </Box>
              <Box flex textAlign={isMobile ? 'start' : 'end'} direction='column' gap='x4'>
                <Body1 semibold>{`${t('RewardsHub.TradingView')} ${
                  reward.tradingViewPlan.name
                }`}</Body1>
                <Body2 color='text-med-em'>
                  {`${t('RewardsHub.Activated on')} ${formatDate(reward.assignmentDate, {
                    formatType: 'dd.MM.yyyy / HH:mm',
                  })}`}
                </Body2>
              </Box>
            </Box>
          ))
        )}
      </Box>
    </Loading>
  )
}
